module.exports = __webpack_public_path__ + "img/running-wild.c4545657.webp";